import React from "react";
import {useTranslation} from "react-i18next";
import {toAbsoluteUrl} from "../../../_helpers";

const FooterCompact = ({today, footerClasses, footerContainerClasses}) => {
    const {t} = useTranslation();

    return (
        <>
            {/* begin::Footer */}
            <div className={`footer bg-white py-4 d-flex flex-lg-column  ${footerClasses}`} id="kt_footer">
                {/* begin::Container */}
                <div
                    className={`${footerContainerClasses} d-flex flex-column flex-md-row align-items-center justify-content-between`}
                >
                    {/* begin::Copyright */}
                    <div className="d-flex align-items-center order-lg-1 order-2">
                        <span className="text-muted font-weight-bold mx-2">{today} ©</span>
                        <a
                            href="https://omnios.ai/winnow/"
                            rel="noopener noreferrer"
                            target="_blank"
                            className=" text-muted font-weight-bold text-hover-primary"
                        >
                            <img
                                className="logo-default mx-2 h-15px"
                                alt="Winnow logo"
                                src={toAbsoluteUrl("/media/logos/winnow.png")}
                            />
                        </a>{" "}
                        - {process.env.REACT_APP_VERSION}/{process.env.REACT_APP_BUILD}
                    </div>
                    {/* end::Copyright */}
                    {` `}
                    {/* begin::Nav */}
                    <div className="nav nav-dark order-1 order-md-2">
                        <a
                            href="https://winnow.video"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link pr-3 pl-0"
                        >
                            {t("FOOTER.ABOUT")}
                        </a>
                        <a
                            href="https://www.linkedin.com/showcase/winnow-video"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link px-3"
                        >
                            LinkedIn
                        </a>
                        <a
                            href="https://twitter.com/VideoWinnow"
                            target="_blank"
                            rel="noopener noreferrer"
                            className="nav-link pl-3 pr-0"
                        >
                            Twitter
                        </a>
                    </div>
                    {/* end::Nav */}
                </div>
                {/* end::Container */}
            </div>
            {/* end::Footer */}
        </>
    );
};

export default FooterCompact;
